import { MapPinOffIcon } from 'lucide-react'
import type { CondicaoUi } from './condicao-ui'

export const foraCerca: CondicaoUi = {
    icone: MapPinOffIcon,
    parametrosIniciais: {},
}
